(() => {
  const containers = document.querySelectorAll('[data-different-bottom-prices-bottoms]');

  if (!containers.length) return;

  const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '0';

    const parts = (amount / 100).toFixed(precision).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return whole + (parts[1] ? `${decimal}${parts[1]}` : '');
  };

  const formatMoney = (cents, format) => {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return format;

    const formatters = {
      amount: () => formatWithDelimiters(cents),
      amount_no_decimals: () => formatWithDelimiters(cents, 0),
      amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, '.', ','),
      amount_with_space_separator: () => formatWithDelimiters(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: () => formatWithDelimiters(cents, 0, ' '),
      amount_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'", '.')
    };
    const formatter = formatters[match[1]] || formatters.amount;
    return format.replace(placeholder, formatter());
  };

  const readVariants = (form) => {
    const variantsElement = form.querySelector('textarea[aria-label="Product JSON"]');
    if (!variantsElement) return [];

    try {
      return JSON.parse(variantsElement.value || variantsElement.textContent);
    } catch (error) {
      return [];
    }
  };

  containers.forEach((container) => {
    const productInformation = container.closest('.product-information--inner');
    const form = productInformation?.querySelector('.product-single__form');
    if (!form) return;

    const variants = readVariants(form);
    const optionGroups = [...form.querySelectorAll(':scope > .variant-wrapper > .variant-input-wrap')];
    const priceElement = container.querySelector('[data-bottoms-price]');
    const compareElement = container.querySelector('[data-bottoms-compare-price]');
    const compareWrapper = compareElement?.closest('del');
    const saleBadge = container.querySelector('[data-bottoms-sale-badge]');
    const moneyFormat = container.dataset.moneyFormat;

    if (!variants.length || !optionGroups.length || !priceElement || !compareElement || !compareWrapper || !saleBadge) {
      return;
    }

    const updateSaleDisplay = (price, compareAtPrice) => {
      const onSale = compareAtPrice > price;
      compareWrapper.hidden = !onSale;
      if (!onSale) {
        saleBadge.textContent = '';
        saleBadge.hidden = true;
        return;
      }

      compareElement.innerHTML = formatMoney(compareAtPrice, moneyFormat);
      const savings = compareAtPrice - price;

      if (container.dataset.saleBadgeType === 'save_amount') {
        saleBadge.innerHTML = container.dataset.saveTemplate.replace(
          '[saved_amount]',
          formatMoney(savings, moneyFormat)
        );
      } else if (container.dataset.saleBadgeType === 'save_percentage') {
        const percentage = `${Math.round((savings * 100) / compareAtPrice)}%`;
        saleBadge.innerHTML = container.dataset.saveTemplate.replace('[saved_amount]', percentage);
      } else {
        saleBadge.textContent = container.dataset.saleLabel;
      }

      saleBadge.hidden = !saleBadge.textContent.trim();
    };

    const showStartingPrice = () => {
      const basePrice = Number(container.dataset.basePrice);
      const baseCompareAtPrice = Number(container.dataset.baseCompareAtPrice);
      const formattedPrice = formatMoney(basePrice, moneyFormat);
      priceElement.innerHTML = container.dataset.startingPriceTemplate.replace('[price]', formattedPrice);
      updateSaleDisplay(basePrice, baseCompareAtPrice);
    };

    const findSelectedVariant = () => {
      const selectedOptions = optionGroups.map((group) => group.querySelector('input:checked')?.value);
      if (selectedOptions.some((value) => value === undefined)) return null;

      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      }) || null;
    };

    const updatePrice = (eventVariant) => {
      const variant = eventVariant || findSelectedVariant();
      if (!variant) {
        showStartingPrice();
        return;
      }

      priceElement.innerHTML = formatMoney(variant.price, moneyFormat);
      updateSaleDisplay(variant.price, variant.compare_at_price || 0);
    };

    form.addEventListener('change', (event) => {
      if (!optionGroups.some((group) => group.contains(event.target))) return;
      window.setTimeout(() => updatePrice(), 0);
    });

    if (window.jQuery) {
      window.jQuery(form).on('variantChange.differentBottomPricesBottoms', (event) => {
        window.setTimeout(() => updatePrice(event.variant), 0);
      });
    }

    showStartingPrice();
    window.setTimeout(() => updatePrice(), 1600);
  });
})();
